import { copyComponent, deleteComponent } from '@/core/item_assistance/creatingNewComponents'
import { bindImageAttributeEvents } from '@/core/input_controls/fileUploader/imageUploader'
import {
	initDataInBoolean,
	initDataInList,
	initDataInTextInput,
	initImageData
} from '@/core/item_assistance/initializeComponentData'
import { createTooltip } from '@/core/shared'
import { mergeData } from '@/core/item_assistance/mergeItemData'

export function initTabAttributeContent () {
	var singleAttributes = []
	var column = 1

	function insertAttribute (position, place) {
		if (!_.isEmpty(singleAttributes)) {
			var wrappedAttribute = '<div class=\'row\'>'
			$(singleAttributes).each(function (index, attribute) {
				wrappedAttribute += attribute.outerHTML
			})
			wrappedAttribute += '</div>'

			if (place == 0) {
				$(position).before(wrappedAttribute)
			} else {
				$(position).after(wrappedAttribute)
			}

			wrappedAttribute = ''
			singleAttributes = []
			column = 1
		}
	}

	var tabs = $('.form').find('.tab-pane')
	tabs.each(function (index, tab) {
		$(tab).children().each(function (index, area) {
			$(area).children().each(function (index, attribute) {
				if ($(attribute).attr('data-attribute-type') == 'single') {
					if (column > 6) {
						insertAttribute($(area), 0)
					}
					singleAttributes.push(area)
					column++
				} else {
					insertAttribute($(area), 0)
				}
			})
		})

		insertAttribute($(tab.lastChild), 1)

		$(tab).children().each(function (index, area) {
			if ($(area.childNodes[0]).attr('data-attribute-type') == 'single') {
				$(area).remove()
			}
		})
	})
}

export function initTabAction () {
	document.activeTabIndex = 0

	$('#groups').find('li').on('click', 'a', this, function () {
		var tabs = $('.tab-content').children()
		tabs.each(function (tabContentIndex, tabContent) {
			$(tabContent).attr('class', 'tab-pane')
		})
		// delete tabs;

		var id = $(this).prop('hash').substring(1, $(this).prop('hash').length)
		var tab = document.getElementById(id)
		$(tab).attr('class', 'tab-pane active')

		var tabs = $('.tab-content').children()
		tabs.each(function (tabContentIndex, tabContent) {
			if ($(tabContent).attr('id') == id) {
				document.activeTabIndex = tabContentIndex
			}
		})
		// delete tabs;
	})
}

function initMultipleAttributeData (attributeName, attributeType, data, defaultData, preferDefault) {
	var attributeData = data
	if (defaultData != undefined && defaultData != null && preferDefault) {
		attributeData = {}
		attributeData[0] = defaultData
	}

	if (attributeType == 'S') {
		initMultipleSimpleAttribute(attributeName, attributeData)
		$('#' + attributeName + '__area').find('div[data-attribute-index]').first().find('.button_minus').bind('click', function () {
			deleteComponent($('#' + attributeName + '__area'), $('#' + attributeName + '__area').find('div[data-attribute-index]').first())
		})
	}

	if (attributeType == 'N') {
		initMultipleNumberAttribute(attributeName, attributeData)
		$('#' + attributeName + '__area').find('div[data-attribute-index]').first().find('.button_minus').bind('click', function () {
			deleteComponent($('#' + attributeName + '__area'), $('#' + attributeName + '__area').find('div[data-attribute-index]').first())
		})
	}

	if (attributeType == 'D') {
		var dateList = []
		_.each(attributeData, function (value, key) {
			if (value !== null && value !== undefined) {
				dateList[key] = value.slice(0, 10)
			}
		})
		initMultipleSimpleAttribute(attributeName, dateList)
		$('#' + attributeName + '__area').find('div[data-attribute-index]').first().find('.button_minus').bind('click', function () {
			deleteComponent($('#' + attributeName + '__area'), $('#' + attributeName + '__area').find('div[data-attribute-index]').first())
		})
	}

	if (attributeType == 'NM') {
		initMultipleNmAttribute(attributeName, attributeData)
		$('#' + attributeName + '__area').find('div[data-attribute-index]').first().find('.button_minus').bind('click', function () {
			deleteComponent($('#' + attributeName + '__area'), $('#' + attributeName + '__area').find('div[data-attribute-index]').first())
		})
	}

	if (attributeType == 'L') {
		initMulticheckboxAttribute(attributeName, attributeData)
	}

	if (attributeType == 'A') {
		initImageAttribute(attributeName, attributeData)
		bindImageAttributeEvents(attributeName)
		$('#' + attributeName + '__image__area').find('div[data-attribute-index]').first().find('.button_minus').bind('click', function () {
			deleteComponent($('#' + attributeName + '__image__area'), $('#' + attributeName + '__image__area').find('div[data-attribute-index]').first(), 'image')
		})

		if (_.isEmpty(attributeData)) {
			$('#' + attributeName + '__image__area').remove()
		}
	}

	if (defaultData) {
		setDefaultDataToMultipleElement('#' + attributeName + '__area', defaultData, attributeType)
	}
}

function initAttributeData (attributeName, attributeType, data, defaultData, preferDefault) {
	var attributeData = data
	if (defaultData != undefined && defaultData != null && preferDefault) {
		attributeData = defaultData
	}

	if (attributeType == 'S') {
		initDataInTextInput(attributeName, attributeData)
	}

	if (attributeType == 'N') {
		initDataInTextInput(attributeName, attributeData ? formatNumber(String(attributeData)) : attributeData)
	}

	if (attributeType == 'D') {
		var date = attributeData ? attributeData.slice(0, 10) : null
		initDataInTextInput(attributeName, date)
	}

	if (attributeType == 'NM') {
		initNmAttribute(attributeName, attributeData)
	}

	if (attributeType == 'B') {
		initDataInBoolean(attributeName, attributeData)
	}

	if (attributeType == 'L') {
		initDataInList('list__' + attributeName, attributeData)
	}

	if (attributeType == 'SL') {
		initSLAttribute(attributeName, attributeData)
		/*$('#' + attributeName + '__area').find("div[data-attribute-index]").first().find(".button_minus").bind('click', function(){
			deleteComponent($('#' + attributeName + '__area'), $('#' + attributeName + '__area').find("div[data-attribute-index]").first());
		});*/
	}
}

function initSLAttribute (attributeName, data) {
	if (data == undefined) {
		return
	}

	var index = 0
	_.each(data, function (value, key) {
		/*if (index > 0) {
			copyComponentSLWithoutCheck(attributeName, key);
		}*/

		if (value != null && value != undefined) {
			// initDataInLabel('label__' + attributeName + "__" + index, key, key);
			initDataInTextInput(attributeName + '__' + key, data[key])
		}
		index++
	})
	// delete index;
}

function initNmAttribute (attributeName, data) {
	if (data == undefined) {
		return
	}

	initDataInTextInput(attributeName, data['val'] ? formatNumber(String(data['val'])) : data['val'])
	initDataInList('list__' + attributeName, data['mu'])
}

function initMultipleSimpleAttribute (attributeName, data) {
	_.each(data, function (value, index) {
		if (index == 0) {
			initDataInTextInput(attributeName + '__' + index, value)
		}

		if (value != null && value != undefined && index > 0) {
			copyComponent(attributeName)
			initDataInTextInput((attributeName + '__' + index), value)
		}
	})
}

function initMultipleNumberAttribute (attributeName, data) {
	_.each(data, function (value, index) {
		value = formatNumber(String(value))
		if (index == 0) {
			initDataInTextInput(attributeName + '__' + index, value)
		}

		if (value != null && value != undefined && index > 0) {
			copyComponent(attributeName)
			initDataInTextInput((attributeName + '__' + index), value)
		}
	})
}

export function initMulticheckboxAttribute (attributeName, data) {

	var $area = $('#' + attributeName + '__area')
	var $checkboxes = $area.find('.checkbox-list').find('input[type=\'checkbox\']').removeAttr('id').prop('checked', false)
	var valuesStr = ''

	_.each(data, function (value, index) {
		var checkbox = _.find($checkboxes, function (element) {
			return $(element).val() === value
		})
		if (checkbox) {
			$(checkbox).prop('checked', true).attr('id', 'list__' + attributeName + '__' + index).parent().addClass('active-item')
			valuesStr += $(checkbox).parent().text() + ', '
		}
	})
	if ($area.find('.checkbox-list input[type=\'checkbox\']:checked').length > 0) {
		$checkboxes.closest('.mcb-item-list').find('.mcb-clear').removeClass('blank')
	}
	var maxCount = $area.attr('max-count')
	if (maxCount > -1 && _.size(data) == maxCount) $area.addClass('restraint')
	$area.find('.value-list').text(valuesStr.length > 0 ? valuesStr.substring(0, valuesStr.length - 1) : '')
}

function initMultipleNmAttribute (attributeName, data) {
	_.each(data, function (value, index) {
		if (index > 0) {
			copyComponent(attributeName)
		}
		if (value != null && value != undefined) {
			initDataInTextInput(attributeName + '__' + index, formatNumber(String(value['val'])))
			initDataInList('list__' + attributeName + '__' + index, value['mu'])
		}
	})
}

function initImageAttribute (attributeName, data) {
	_.each(data, function (value, index) {
		if (index > 0) {
			copyComponent(attributeName + '__image', 'image')
		}
		if (value != null && value != undefined) {
			initImageData(attributeName + '__image__' + index, value)
		}
	})
}

function initData (itemData, sourceItemData, itemStructure, preferDefault) {
	var mergedData = sourceItemData ? mergeData(itemData, sourceItemData) : itemData
	_.each(itemStructure, function (attrConfig, attrName) {
		if (attrConfig['multiple']) {
			initMultipleAttributeData(attrName, attrConfig['type'], mergedData[attrName], attrConfig['defaultValue'], preferDefault)
		} else {
			initAttributeData(attrName, attrConfig['type'], mergedData[attrName], attrConfig['defaultValue'], preferDefault)
		}
	})
	setAttributesDescriptionTooltip()
}

function setDefaultDataToMultipleElement (elementId, defaultData, attributeType) {
	var data = {}
	if (attributeType == 'S' || attributeType == 'N' || attributeType == 'D') {
		data['input'] = defaultData
	} else if (attributeType == 'NM') {
		data['input'] = defaultData['val']
		data['select'] = defaultData['mu']
	} else if (attributeType == 'L') {
		data['select'] = defaultData
	}
	$(elementId).data('defaultData', data)
}

export function setAttributesDescriptionTooltip () {
	$('.form').find('label[data-description]').each(function () {
		createTooltip($(this).attr('id'), $(this).attr('data-description'), 'top')
		$(this).removeAttr('data-description')
	})
	$('.tooltip').css('word-break', 'break-all')
}

function formatNumber (value) {
	var setting = window.editableTradeItem.getDecimalOrDigitSettings()
	var separator = '$1' + setting.digitGroupingSeparator

	if ((setting.decimalSeparator !== '.') && (value.indexOf('.') > 0)) {
		value = value.replace('.', setting.decimalSeparator)
	} else {
		value = value.replace(',', setting.decimalSeparator)
	}

	if (setting.digitGroupingPattern !== '0') {
		if ((value.indexOf('.') > 0) || (value.indexOf(',') > 0)) {
			return value.replace(/(\d)(?=(\d\d\d)+([^\d]|$)(.|,))/g, separator)
		} else {
			return value.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, separator);
		}
	}
	return value;
}
